// extracted by mini-css-extract-plugin
module.exports = {"field":"SettingPricePane_field__3_WPF","text":"SettingPricePane_text__2iTO6"};